import React from 'react';
import PropTypes from 'prop-types';
import { Offcanvas } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';
import './filterSidebar.scss';

const FilterSidebar = ({ show, onHide, children }) => {
    const placement = isMobileOnly ? 'bottom' : 'end';
    const variantClass = isMobileOnly ? 'filter-sidebar--fullscreen' : 'filter-sidebar--slide';

    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement={placement}
            className={`filter-sidebar ${variantClass}`}
            backdrop={true}
            scroll={false}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {children}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

FilterSidebar.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default FilterSidebar;
